export default __webpack_public_path__ + "static/media/big-vertical.ffd18d71.jpg";